import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconHomeLine"><Path fillRule="evenodd" clipRule="evenodd" d="M13.7414 1.95572C12.7284 1.1269 11.2716 1.1269 10.2586 1.95572L4.0086 7.06936C3.37022 7.59167 3 8.37293 3 9.19774V18.25C3 19.7688 4.23122 21 5.75 21H18.25C19.7688 21 21 19.7688 21 18.25V9.19774C21 8.37293 20.6298 7.59167 19.9914 7.06936L13.7414 1.95572ZM7.75 15.5C7.33579 15.5 7 15.8358 7 16.25C7 16.6642 7.33579 17 7.75 17H16.25C16.6642 17 17 16.6642 17 16.25C17 15.8358 16.6642 15.5 16.25 15.5H7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeLine;
